export enum PrebuiltsActionTypeEnum {
    PrebuiltMasterNew = 'PrebuiltMasterNew',
    PrebuiltMasterEdit = 'PrebuiltMasterEdit',
}
export type PrebuiltsActionType = keyof typeof PrebuiltsActionTypeEnum;
